import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import secureLocalStorage from "react-secure-storage";
import { useSignOut } from 'react-auth-kit';


export default function Logout() {
   const signOut = useSignOut(); 
   const navigate = useNavigate();
   
   useEffect(() => { 
        signOut();
        navigate('/Home');
   });

}